<template>
  <button class="text-blue p-1 relative flex items-center" @click="share">
    <Share2Icon class="mr-2" size="1x" />
    <span v-if="!shared">
      {{ $t('teilen') }}
    </span>
    <span v-else>
      {{ $t('geteilt') }}
    </span>
    <input
      ref="input"
      type="text"
      :value="link"
      class="w-1 left-0 top-0 pointer-events-none absolute opacity-0"
    />
  </button>
</template>

<script>
import { Share2Icon } from 'vue-feather-icons';

export default {
  components: {
    Share2Icon
  },
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shared: false
    };
  },
  computed: {
    link() {
      return `${window.location.protocol}//${window.location.host}/foyer/${this.appointment.uuid}`;
    },
    canShare() {
      return 'share' in navigator;
    }
  },
  methods: {
    share() {
      if (this.canShare) {
        navigator
          .share({
            url: this.link
          })
          .then(() => {
            this.shared = true;
          });
      } else {
        this.$refs.input.select();
        this.$refs.input.setSelectionRange(0, 99999);

        document.execCommand('copy');

        this.shared = true;
      }
    }
  }
};
</script>

<style></style>
